import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowTable: Components<Theme>['MuiTable'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      borderCollapse: 'collapse',
      borderColor: theme.palette.surface.secondary,
      // remove cell's bottom border in last row in last table element
      '& > *:last-child': {
        '.MuiTableRow-root:last-of-type': {
          '.MuiTableCell-root': {
            borderBottom: 'none',
          },
        },
      },
    }),
  },
};
